import { render, staticRenderFns } from "./ContactInfoAwsDocuments.vue?vue&type=template&id=6f859ffd&scoped=true"
import script from "./ContactInfoAwsDocuments.vue?vue&type=script&lang=ts"
export * from "./ContactInfoAwsDocuments.vue?vue&type=script&lang=ts"
import style0 from "./ContactInfoAwsDocuments.vue?vue&type=style&index=0&id=6f859ffd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f859ffd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f859ffd')) {
      api.createRecord('6f859ffd', component.options)
    } else {
      api.reload('6f859ffd', component.options)
    }
    module.hot.accept("./ContactInfoAwsDocuments.vue?vue&type=template&id=6f859ffd&scoped=true", function () {
      api.rerender('6f859ffd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactInfoAwsDocuments.vue"
export default component.exports